<template>
  <div class="ranking">
    <p class="title">팀랭킹</p>
    <div class="rankingBox" v-if="rankingStatus">
      <table>
        <thead>
          <tr v-if="isMobile">
            <th>순위</th>
            <th>팀</th>
            <th>승/무/패</th>
            <th>득점</th>
            <th>승점</th>
          </tr>
          <tr v-else>
            <th>순위</th>
            <th>팀</th>
            <th>승</th>
            <th>무</th>
            <th>패</th>
            <th>득점</th>
            <th>승점</th>
          </tr>
        </thead>
        <tbody v-for="(team, index) in list" :key="index">
          <tr :class="{ active: team.active }">
            <td class="rank">{{ team.rank }}</td>
            <td class="team">
              <img :src="getEmblem(team.team_id)" alt="emblem"> {{ team.team_name }}
            </td>
            <td v-if="isMobile" class="game">
              {{ team.win_cnt }}/{{ team.tie_cnt }}/{{ team.loss_cnt }}
            </td>
            <td v-if="!isMobile" class="game">
              {{ team.win_cnt }}
            </td>
            <td v-if="!isMobile" class="game">
              {{ team.tie_cnt }}
            </td>
            <td v-if="!isMobile" class="game">
              {{ team.loss_cnt }}
            </td>
            <td class="score">{{ team.gain_goal }}</td>
            <td class="point">{{ team.gain_point }}</td>
          </tr>
          <tr v-if="list.length !== index+1">
            <td class="space" colspan="7"></td>
          </tr>
        </tbody>
      </table>
    </div>
    <div v-else class="noData">
      준비중입니다
    </div>
  </div>
</template>

<script>
import {sortData, getEmblem} from '@/lib';
import {matchTeamArea} from "@/lib/match";

export default {
  name : 'Ranking',
  data() {
    return {
      isMobile: false,
      list: [],
      rankingStatus: false,
      seasonType: this.$store.getters['getSeasonType'],
    }
  },
  mounted () {
    window.addEventListener('resize', this.onResize);
    this.$nextTick(() => {
      this.onResize()
    })
    this.init();
  },
  methods: {
    async init() {
      const {data} = await this.$http.get('game/rank');
      if(data.success && data.data.all_rank) {
        this.rankingStatus = true;
        let idx = 0;
        data.data.all_rank.forEach(item => {
          if(item.team_id !== "K07" && idx < 4) {
            this.list.push(item);
            idx++;
          }
        });

        this.list.unshift(data.data.team_rank);
        this.list[0].active = true;
      }

      this.list.map( item => {
        item.team_name = matchTeamArea(item.team_id);
      })

      // eslint-disable-next-line vue/no-mutating-props
      if(!this.seasonType.mainRanking) this.rankingStatus = this.seasonType.mainRanking;
    },
    onResize () {
      this.isMobile = window.innerWidth < 960
    },
    getEmblem,
    sortData
  }
}
</script>

<style scoped>
.noData {
  text-align: center;
  padding: 50px 0;
  font-size: 16px;
  color: #999;
}
</style>
